import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Toote kirjeldus

  <span style="color:#85c1dc;">**FI:**</span>
  Tuotekuvaus

  <span style="color:#85c1dc;">**RU:**</span>
  Описание товара
*/
/* @__NO_SIDE_EFFECTS__ */
const m1227 = msg(
  mf`Toote kirjeldus`,
  mf`Tuotekuvaus`,
  mf`Описание товара`,
)

export { m1227 as 'w.module.product_description.product_text' }